<!--suppress HtmlFormInputWithoutLabel -->
<template>
    <div class="container" v-if="type">
        <div class="horizontal-flex-box">
            <div class="event-tf mdc-text-field" data-mdc-auto-init="MDCTextField">
                <i class="material-icons mdc-text-field__icon"/>
                <input type="datetime-local" :id="namePrefix('date_start_at')" :name="namePrefix('date_start_at')" class="mdc-text-field__input" :value="this.startOfToday()" required/>
                <label :name="namePrefix('date_start_at')" class="mdc-floating-label">開始時間日期</label>
                <div class="mdc-line-ripple"></div>
            </div>

            <div class="event-tf mdc-text-field" data-mdc-auto-init="MDCTextField">
                <i class="material-icons mdc-text-field__icon"/>
                <input type="datetime-local" :id="namePrefix('date_end_at')" :name="namePrefix('date_end_at')" class="mdc-text-field__input" :value="this.endOfToday()" required/>
                <label :for="namePrefix('date_end_at')" class="mdc-floating-label">結束時間日期</label>
                <div class="mdc-line-ripple"></div>
            </div>
        </div>

        <div class="horizontal-flex-box" v-if="type !== 'date' && type !== 'weekdays' && !except">
            <div class="event-tf mdc-text-field" data-mdc-auto-init="MDCTextField">
                <i class="material-icons mdc-text-field__icon"/>
                <input type="time" :id="namePrefix('time_start_at')" :name="namePrefix('time_start_at')" class="mdc-text-field__input" :value="this.currentHour()"/>
                <label :for="namePrefix('time_start_at')" class="mdc-floating-label">開始時段</label>
                <div class="mdc-line-ripple"></div>
            </div>

            <div class="event-tf mdc-text-field" data-mdc-auto-init="MDCTextField">
                <i class="material-icons mdc-text-field__icon"/>
                <input type="time" :id="namePrefix('time_end_at')" :name="namePrefix('time_end_at')" class="mdc-text-field__input" :value="this.endOfCurrentHour()">
                <label :for="namePrefix('time_end_at')" class="mdc-floating-label">結束時段</label>
                <div class="mdc-line-ripple"></div>
            </div>
        </div>

        <div class="horizontal-flex-box" v-if="!except">
            <div class="event-tf mdc-text-field" data-mdc-auto-init="MDCTextField" v-if="type !== 'date'">
                <i class="material-icons mdc-text-field__icon"/>
                <input type="text" :id="namePrefix('weekdays')" :name="namePrefix('weekdays')" class="mdc-text-field__input" :value="this.weekDays()">
                <label :for="namePrefix('weekdays')" class="mdc-floating-label">每逢星期(0-6, 0 = 星期天)</label>
                <div class="mdc-line-ripple"></div>
            </div>
            <div class="event-tf mdc-text-field" data-mdc-auto-init="MDCTextField" v-if="type === 'person'">
                <i class="material-icons mdc-text-field__icon"/>
                <input type="number" :id="namePrefix('person_min')" :name="namePrefix('person_min')" class="mdc-text-field__input" :value="this.personMin()" min="1" max="9999" step="1">
                <label :for="namePrefix('person_min')" class="mdc-floating-label">最少人數</label>
                <div class="mdc-line-ripple"></div>
            </div>
            <div class="event-tf mdc-text-field" data-mdc-auto-init="MDCTextField" v-if="type === 'person'">
                <i class="material-icons mdc-text-field__icon"/>
                <input type="number" :id="namePrefix('person_max')" :name="namePrefix('person_max')" class="mdc-text-field__input" :value="this.personMax()" min="1" max="9999" step="1">
                <label :for="namePrefix('person_max')" class="mdc-floating-label">最大人數</label>
                <div class="mdc-line-ripple"></div>
            </div>
        </div>

        <div v-if="except"  class="event-form__buttons-box">
            <button id="event-form-delete" type="button" class="event-button delete material-icons" v-on:click.prevent="destroy">close</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'except': {
                type: Boolean,
                default: false,
            },
            'index': {
                default: 0,
            },
            'type': {
                default: null,
            },
            'data': {
                default: null,
            }
        },
        methods: {
            namePrefix(name) {
                return this.except ? `exceptions[${this.index}][${name}]` : name;
            },
            destroy() {
                this.$destroy();
                this.$el.parentNode.removeChild(this.$el);
            },
            startOfToday() {
                if (this.data && this.data.hasOwnProperty('date_start_at')) {
                    return this.data.date_start_at;
                }

                let date = new Date();
                let yyyy = date.getFullYear();
                let MM = ('0' + (date.getMonth() + 1)).slice(-2);
                let dd = ('0' + date.getDate()).slice(-2);

                return yyyy + '-' + MM + '-' + dd + 'T00:00';
            },
            endOfToday() {
                if (this.data && this.data.hasOwnProperty('date_end_at')) {
                    return this.data.date_end_at;
                }

                let date = new Date();
                let yyyy = date.getFullYear();
                let MM = ('0' + (date.getMonth() + 1)).slice(-2);
                let dd = ('0' + date.getDate()).slice(-2);

                return yyyy + '-' + MM + '-' + dd + 'T23:59';
            },
            currentHour() {
                // if (this.data && this.data.hasOwnProperty('time_start_at')) {
                //     return this.data.time_start_at;
                // }
                //
                // if (this.except) {
                //     return ''
                // }
                //
                // let date = new Date();
                // return date.getHours() + ":00";
                return '00:00';
            },
            endOfCurrentHour() {
                // if (this.data && this.data.hasOwnProperty('time_end_at')) {
                //     return this.data.time_end_at;
                // }
                //
                // if (this.except) {
                //     return ''
                // }
                //
                // let date = new Date();
                // return date.getHours() + ":59";
                return '23:59'
            },
            personMax() {
                if (this.data && this.data.hasOwnProperty('person_max')) {
                    return this.data.person_max;
                }

                if (this.except) {
                    return ''
                }

                return '10'
            },
            personMin() {
                if (this.data && this.data.hasOwnProperty('person_min')) {
                    return this.data.person_min;
                }

                if (this.except) {
                    return ''
                }
                return '5'
            },
            weekDays() {
                if (this.data && this.data.hasOwnProperty('weekdays')) {
                    return this.data.weekdays;
                }

                if (this.except) {
                    return ''
                }

                return '1,2,3,4,5'
            }
        },
        mounted() {
            this.$nextTick(function () {
                window.mdc.autoInit();
            });
        }
    }
</script>

<style lang="scss">
    .container {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 10px 0;

        .horizontal-flex-box {
            display: flex;
        }
    }

    .event-form__buttons-box {
        position: absolute;
        display: none;
        top: 2px;
        right: 2px;

        #event-form-delete.event-button {
            font-size: 1.5em;
            background: none;
            border: none;
            padding: 0;
            outline: none;

            &.delete {

            }
        }
    }

    .container:hover .event-form__buttons-box {
        display: block;
    }

</style>